import Card from "../../components/shared/card";
import ThemedSpinner from "../../components/shared/spinner";
import Typography from "../../components/shared/typography";
import { MedicalRecordRequestsList } from "../../medical-record-requests/components/MedicalRecordRequestsList";
import { useMedicalRecordRequestsContext } from "../../medical-record-requests/context/MedicalRecordRequestsContext";

export function MedicalRecordRequestsLayout() {
  const { requests, isLoading, isError, error } =
    useMedicalRecordRequestsContext();

  if (isLoading) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="flex justify-center">
          <ThemedSpinner />
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="container mx-auto px-4 py-8">
        <Card variant="cream" elevation={1}>
          <Card.Body className="space-y-2">
            <Typography variant="h4" className="text-terracotta">
              Unable to load medical record requests
            </Typography>
            <Typography variant="body1" className="text-terracotta">
              {error instanceof Error
                ? error.message
                : "An unexpected error occurred."}
            </Typography>
          </Card.Body>
        </Card>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8 space-y-6">
      <div className="flex flex-col gap-2">
        <Typography variant="h2" className="text-terracotta">
          Medical Record Requests
        </Typography>
        <Typography variant="body1" className="text-terracotta/80">
          Review incoming medical record requests and mark them when they are
          ready to send.
        </Typography>
      </div>

      <Card variant="cream" elevation={1}>
        <Card.Body>
          {requests.length === 0 ? (
            <Typography variant="body1" className="text-terracotta">
              There are no medical record requests yet.
            </Typography>
          ) : (
            <MedicalRecordRequestsList
              items={requests}
              getDetailPath={(id) => `/medical-records/requests/all/${id}`}
            />
          )}
        </Card.Body>
      </Card>
    </div>
  );
}

export default MedicalRecordRequestsLayout;
